export default {
  items: [{
    name: 'Dashboard',
    url: '/home',
    icon: 'far fa-home-heart',
    action:['adminuser','miniuser','dtuser']
  },{
    name: 'กำหนดขอบเขต',
    url: '/map/polygon',
    icon: 'far fa-draw-polygon',
    action:['adminuser']
  },{
    name: 'พิกัดตำแหน่ง',
    url: '/map/gps',
    icon: 'far fa-map-marked-alt',
    action:['adminuser']
  },{
    name: 'ยอดขายรายคน',
    url: '/wallsmen/sales',
    icon: 'far fa-poll-people',
    action:['adminuser','miniuser','dtuser']
  },{
    name: 'สมัครวอลล์แมน',
    url: '/wallsmen/register',
    icon: 'far fa-registered',
    action:['miniuser']
  },{
    name: 'ประวัติวอลล์แมน',
    url: '/wallsmen',
    icon: 'fab fa-black-tie',
    action:['adminuser','miniuser','dtuser']
  },{
    name: 'ทะเบียนรถ/บาร์โค้ด',
    url: '/bikes',
    icon: 'far fa-barcode-alt',
    action:['adminuser','miniuser','dtuser']
  },{
    name: 'สินค้าคงคลัง',
    url: '/inventories',
    icon: 'far fa-warehouse-alt',
    action:['miniuser','dtuser']
  },{
    name: 'ออกจากระบบ',
    url: '/logout',
    icon: 'fas fa-sign-out-alt',
    action:['adminuser','miniuser','dtuser']
  }]
}
